import {
    AmbientLight,
    DirectionalLight,
    sRGBEncoding,
    Mesh,
    MeshStandardMaterial,
    PlaneGeometry,
} from 'three';
import Experience from '../Experience.js';

export default class Environment {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.sizes = this.experience.sizes;

        // Debug
        this.debug = this.experience.debug;
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Environment');
        }

        // Lights
        this.setAmbientLight();
        // this.setSunLight();
    }

    setAmbientLight() {
        this.ambientLight = new AmbientLight(0xffffff, 3.5);
        this.scene.add(this.ambientLight);

        if (this.debug.active) {
            this.debugFolder
                .add(this.ambientLight, 'intensity')
                .name('Ambient light intensity')
                .min(0)
                .max(10)
                .step(0.001);
        }
    }

    setSunLight() {
        this.directionalLight1 = new DirectionalLight(0xffffff, 3.75);
        // this.sunLight.castShadow = true;
        // this.sunLight.shadow.camera.far = 15;
        // this.sunLight.shadow.mapSize.set(1024, 1024);
        // this.sunLight.shadow.normalBias = 0.05;
        // this.directionalLight1.position.set(3.5, -0.5, -1.25);
        this.scene.add(this.directionalLight1);

        // this.directionalLight2 = new DirectionalLight(0xffffff, 1);
        // this.sunLight2.position.set(-3.5, 2, -1.25);
        // this.scene.add(this.directionalLight2);

        if (this.debug.active) {
            this.debugFolder
                .add(this.directionalLight1, 'intensity')
                .name('light1Intensity')
                .min(0)
                .max(10)
                .step(0.001);

            this.debugFolder
                .add(this.directionalLight1.position, 'x')
                .name('light1X')
                .min(-10)
                .max(10)
                .step(0.001);

            this.debugFolder
                .add(this.directionalLight1.position, 'y')
                .name('light1Y')
                .min(-10)
                .max(10)
                .step(0.001);

            this.debugFolder
                .add(this.directionalLight1.position, 'z')
                .name('light1Z')
                .min(-10)
                .max(10)
                .step(0.001);

            // this.debugFolder
            //     .add(this.directionalLight2, 'intensity')
            //     .name('light2Intensity')
            //     .min(0)
            //     .max(10)
            //     .step(0.001);

            // this.debugFolder
            //     .add(this.directionalLight2.position, 'x')
            //     .name('light2ightX')
            //     .min(-360)
            //     .max(360)
            //     .step(0.001);

            // this.debugFolder
            //     .add(this.directionalLight2.position, 'y')
            //     .name('light2ightY')
            //     .min(-360)
            //     .max(360)
            //     .step(0.001);

            // this.debugFolder
            //     .add(this.directionalLight2.position, 'z')
            //     .name('light2ightZ')
            //     .min(-360)
            //     .max(360)
            //     .step(0.001);
        }
    }

    // N.B.: Currently not used
    setFloorReflector() {
        const mirrorGeometry = new PlaneGeometry(100, 100);
        this.mirror = new LayersReflectorWithDepth(
            mirrorGeometry,
            {
                clipBias: 0.003,
                textureWidth: this.sizes.width * this.sizes.pixelRatio,
                textureHeight: this.sizes.height * this.sizes.pixelRatio,
                color: 0x889999,
            },
            [1]
        );
        this.mirror.rotateX(-Math.PI / 2);
        this.mirror.position.y = 0.7;
        // mirror.material.uniforms.opacity.value = 2;
        this.scene.add(mirror);

        if (this.debug.active) {
            this.debugFolder
                .add(mirror.position, 'y')
                .name('Ground mirror position')
                .min(-10)
                .max(10)
                .step(0.001);
        }
    }

    // N.B.: Currently not used
    setEnvironmentMap() {
        this.environmentMap = this.resources.environments.environmentMap.file;
        this.environmentMapIntensity = 2.5;
        this.environmentMap.encoding = sRGBEncoding;
        this.scene.environment = this.environmentMap;

        if (this.debug.active) {
            this.debugFolder
                .add(this, 'environmentMapIntensity')
                .min(0)
                .max(5)
                .step(0.001)
                .onChange(() => {
                    this.updateAllMaterials();
                });
        }
    }

    // N.B.: Currently not used
    updateAllMaterials() {
        this.scene.traverse((child) => {
            if (child instanceof Mesh && child.material instanceof MeshStandardMaterial) {
                child.material.envMap = this.environmentMap;
                child.material.envMapIntensity = this.environmentMapIntensity;
            }
        });
    }
}
